import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import ReactSlider from '@src/common/ReactSliderRegister';
import { SCREEN_SIZE } from '@src/config/constant';

const loginLeft = {
    backgroundImage: 'url("/images/Group_1000005712.png")',
    backgroundColor: "#0B1E51",
    backgroundRepeat: "repeat-y",
    backgroundPosition: "center",
    borderRadius: "25px"
};

function RegisterSlider() {
    const [isMobileView, setIsMobileView] = useState<boolean>(() => {
        if (typeof window === "undefined") {
            return false;
        }
        return window.innerWidth < SCREEN_SIZE;
    });

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        const handleResize = () => {
            setIsMobileView(window.innerWidth < SCREEN_SIZE);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const isSignupMobile =
        isMobileView && window.location.pathname === "/signup/start";

    if (!isMobileView) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <div
                className={`login-left-panel ${isSignupMobile ? "left-slider-mobile" : ""}`}
                 style={{...loginLeft, ...(isSignupMobile && { borderRadius: "0px" })}}
            >
                <ReactSlider screenType="Register" />
            </div>
        </>
    );
}

export default RegisterSlider;
